import { useSelector } from "react-redux"
import { getUser } from "../store/auth/auth.selectors"
import {isUserPackageRoute} from "../helpers/helpers";

export const useCan = (permission) => {
  const userData = useSelector(getUser)
  const { permissions } = userData || {}

  if (!permissions) return null

  if (isUserPackageRoute()) {
    if (permission === "schedule.view") return false
  }

  if (Array.isArray(permission)) {
    return permission.every((p) => permissions.includes(p))
  }

  return permissions.includes(permission)
}
